// extracted by mini-css-extract-plugin
module.exports = {"main":"FeedbackMain_main__1iwUN","textarea_input":"FeedbackMain_textarea_input__1Ypbi","footer_btn":"FeedbackMain_footer_btn__3daEK"};